import React from 'react';
import { ControlId } from './controlCenter.types';
import { SnowLevels } from '../../snowfall-api';
import { FirefliesLevels } from '../../fireflies-api';

// Icons
const ThemeIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" fill="none" />
    <path d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21V3Z" fill="currentColor" />
  </svg>
);

const NoteIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    />
  </svg>
);

const MegaphoneIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46"
    />
  </svg>
);

const SnowflakeIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
    <path d="M460-293.69 323.15-158.85q-5.61 5.62-13.65 5.62t-13.65-6.62q-6.62-5.61-6.62-13.65t6.62-14.65L460-352.31V-460H352.31L187.15-294.85q-5.61 5.62-13.65 5.62t-14.65-6.62q-5.62-5.61-5.62-13.65t5.62-13.65L293.69-460H119q-7.77 0-13.38-5.73Q100-471.46 100-480q0-7.77 5.73-13.88Q111.46-500 120-500h173.69L158.85-635.85q-5.62-5.61-5.62-13.65t6.62-14.65q5.61-5.62 13.65-5.62t14.65 5.62L352.31-500H460v-107.69L294.85-771.85q-5.62-5.61-5.62-13.65t6.62-14.65q5.61-5.62 13.65-5.62t13.65 5.62L460-666.31V-840q0-7.77 5.73-13.88Q471.46-860 480-860q7.77 0 13.88 6.12Q500-847.77 500-840v173.69l135.85-133.84q5.61-5.62 13.65-5.62t14.65 5.62q5.62 6.61 5.62 14.65t-5.62 13.65L500-607.69V-500h107.69l164.16-164.15q5.61-5.62 13.65-5.62t14.65 6.62q5.62 5.61 5.62 13.65t-5.62 13.65L666.31-500H840q7.77 0 13.88 6.12Q860-487.77 860-480q0 8.54-6.12 14.27Q847.77-460 840-460H666.31l133.84 136.85q5.62 5.61 5.62 13.65t-5.62 13.65q-6.61 6.62-14.65 6.62t-13.65-6.62L607.69-460H500v107.69l164.15 165.16q5.62 5.61 5.62 13.65t-6.62 14.65q-5.61 5.62-13.65 5.62t-13.65-5.62L500-293.69V-119q0 7.77-6.12 13.38Q487.77-100 480-100q-8.54 0-14.27-5.73T460-120v-173.69Z" />
  </svg>
);

const SnowPileIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
    <path d="M120-200v-80l280-360 160 160 280-280v560H120Zm80-80h560v-288L552-360 392-520 200-280v80Zm0 0h560-560Z" />
  </svg>
);

const FireflyIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="neo-cc-firefly-icon">
    <circle cx="12" cy="12" r="4" opacity="0.9" />
    <circle cx="12" cy="12" r="6" opacity="0.4" />
    <circle cx="12" cy="12" r="8" opacity="0.15" />
  </svg>
);

const FocusIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
    />
  </svg>
);

const NightModeIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"
    />
  </svg>
);

const BeakerIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"
    />
  </svg>
);

const CogIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);

const CalendarIcon: React.FC<{ day: number }> = ({ day }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
    />
    <text x="12" y="17" textAnchor="middle" fontSize="8" fontWeight="600" fill="currentColor" stroke="none">
      {day}
    </text>
  </svg>
);

export interface ControlRendererProps {
  id: ControlId;
  // State
  darkMode: boolean;
  focusMode: boolean;
  nightMode: boolean;
  snowPileEnabled: boolean;
  snowLevel: string;
  maxSnowLevel: number;
  firefliesLevel: string;
  showTestMenu: boolean;
  currentDay: number;
  // Handlers
  toggleDarkMode: () => void;
  handleReleaseNotes: () => void;
  handleQuickNotes: () => void;
  handleManageAccount: () => void;
  toggleFocusMode: () => void;
  toggleNightMode: () => void;
  toggleTestMenu: () => void;
  handleCalendar: () => void;
  setSnowPileEnabled: (enabled: boolean) => void;
  setSnowLevel: (level: SnowLevels) => void;
  setFirefliesLevel: (level: FirefliesLevels) => void;
  // Translations
  translate: (key: string) => string;
}

export const ControlRenderer: React.FC<ControlRendererProps> = ({
  id,
  darkMode,
  focusMode,
  nightMode,
  snowPileEnabled,
  snowLevel,
  maxSnowLevel,
  firefliesLevel,
  showTestMenu,
  currentDay,
  toggleDarkMode,
  handleReleaseNotes,
  handleQuickNotes,
  handleManageAccount,
  toggleFocusMode,
  toggleNightMode,
  toggleTestMenu,
  handleCalendar,
  setSnowPileEnabled,
  setSnowLevel,
  setFirefliesLevel,
  translate,
}) => {
  switch (id) {
    case 'theme':
      return (
        <button type="button" className="neo-cc-pill" onClick={toggleDarkMode}>
          <div className="neo-cc-pill-icon">
            <ThemeIcon />
          </div>
          <div className="neo-cc-pill-content">
            <span className="neo-cc-pill-title">{translate('theme')}</span>
            <span className="neo-cc-pill-subtitle">{darkMode ? translate('dark-mode') : translate('light-mode')}</span>
          </div>
        </button>
      );

    case 'versions':
      return (
        <button type="button" className="neo-cc-pill" onClick={handleReleaseNotes}>
          <div className="neo-cc-pill-icon">
            <MegaphoneIcon />
          </div>
          <div className="neo-cc-pill-content">
            <span className="neo-cc-pill-title">{translate('versions')}</span>
            <span className="neo-cc-pill-subtitle">v{process.env.BUILD_PCKG_VERSION}</span>
          </div>
        </button>
      );

    case 'quick-notes':
      return (
        <button type="button" className="neo-cc-pill" onClick={handleQuickNotes}>
          <div className="neo-cc-pill-icon">
            <NoteIcon />
          </div>
          <div className="neo-cc-pill-content">
            <span className="neo-cc-pill-title">{translate('notes')}</span>
          </div>
        </button>
      );

    case 'account':
      return (
        <button type="button" className="neo-cc-round" onClick={handleManageAccount} title={translate('account-verwalten')}>
          <CogIcon />
        </button>
      );

    case 'focus-mode':
      return (
        <button type="button" className={`neo-cc-round ${focusMode ? 'active' : ''}`} onClick={toggleFocusMode} title={translate('focus-mode')}>
          <FocusIcon />
        </button>
      );

    case 'night-mode':
      return (
        <button type="button" className={`neo-cc-round ${nightMode ? 'active' : ''}`} onClick={toggleNightMode} title={translate('night-mode')}>
          <NightModeIcon />
        </button>
      );

    case 'calendar':
      return (
        <button type="button" className="neo-cc-round" onClick={handleCalendar} title={translate('calendar')}>
          <CalendarIcon day={currentDay} />
        </button>
      );

    case 'developer-test':
      return (
        <button type="button" className={`neo-cc-round ${showTestMenu ? 'active' : ''}`} onClick={toggleTestMenu} title="Test">
          <BeakerIcon />
        </button>
      );

    case 'snow-pile':
      return (
        <button type="button" className={`neo-cc-pill ${snowPileEnabled ? 'active' : ''}`} onClick={() => setSnowPileEnabled(!snowPileEnabled)}>
          <div className="neo-cc-pill-icon">
            <SnowPileIcon />
          </div>
          <div className="neo-cc-pill-content">
            <span className="neo-cc-pill-title">{translate('schnee')}</span>
          </div>
        </button>
      );

    case 'snow-level':
      return (
        <div className="neo-cc-slider">
          <span className="neo-cc-slider-label">{translate('stufe')}</span>
          <div className="neo-cc-slider-row">
            <SnowflakeIcon />
            <input
              type="range"
              className="neo-cc-slider-track"
              min="0"
              max={maxSnowLevel}
              value={snowLevel}
              onChange={e => setSnowLevel(e.target.value as SnowLevels)}
            />
          </div>
        </div>
      );

    case 'fireflies-level':
      return (
        <div className="neo-cc-slider">
          <span className="neo-cc-slider-label">{translate('fireflies')}</span>
          <div className="neo-cc-slider-row">
            <FireflyIcon />
            <input
              type="range"
              className="neo-cc-slider-track"
              min="0"
              max="5"
              value={firefliesLevel}
              onChange={e => setFirefliesLevel(e.target.value as FirefliesLevels)}
            />
          </div>
        </div>
      );

    default:
      return null;
  }
};
